import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CarrierService } from 'app/services/carrier.service';
import { CurrencyFormat } from 'app/pipes/currencyFormat.pipe';
import { PopupService } from 'app/services/shared/popup.service';
import { AuthWebService } from 'app/services/authweb.service';
import { accounting } from 'accounting';
import { PermitService } from 'app/services/permit.service';
import { ApplicationService } from 'app/services/application.service';
import { StatusService } from 'app/services/status.service';
import { RouteService } from 'app/services/route.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from 'app/services/storage.service';
import { VehicleTypeService } from 'app/services/vehicle-type.service';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import { data } from 'jquery';
import { PermitTypeService } from 'app/services/permit-type.service';

declare var $;

@Component({
  selector: 'app-permit-list-application',
  templateUrl: './permit-list-application.component.html',
  styleUrls: ['./permit-list-application.component.css'],
  providers: [CurrencyFormat, RouteService]
})
export class PermitListApplicationComponent implements OnInit {
  dataCntrl: any = { carrierID: -1, carrier: {}, applications: [], applicationtype: {}, vehicles: [], applicationId: -1 };
  pageSize: number = 10;
  pageSizeMax: number = 2147483647; // C# Int32.MaxValue
  pageNumber: number = 1;
  Count: number = 0;
  pageload: boolean;
  gridload: boolean = false;
  direction = false;
  user
  acc: any = { link_person: '', status: '' };
  application: any;
  status: any = "";
  statuses: any = [];
  routes: any = [];
  vehTypes: any = {};
  statusesFilter: any = [];
  selectedItems: any = [];
  selectedPermitTypes: any = [];
  dropdownSettings: any = {};
  ShowFilter = false;
  keyword: any = {};
  permitNumber: String;

  carrierNumber: string;
  routeName: string;
  flags = { flagAN: 1, flagNM: 1, flagLU: 1, flagCT: 1, flagAP: 1, flagPT: 1, flagST: 1, flagDS: 1 };
  ranks = { flagAN: 1, flagNM: 2, flagLU: 3, flagCT: 4, flagAP: 5, flagPT: 6, flagST: 7, flagDS: 8 };
  sortLabels = { flagAN: "AccountNumber", flagNM: "Name", flagLU: "LeadUser", flagCT: "CarrierType", flagAP: "ApplicationNumber", flagPT: "PermitType", flagST: "Status", flagDS: "DateSubmitted" };
  limitSelection = false;
  criteria = "DateSubmitted";
  rankCtrl: number = 8;
  isDef: boolean = true;
  permits: any = [];
  isEmpty: boolean = false;
  count: number = 0;
  message = 'Loading permits. Please wait...';
  permitObj: any = { permits: [], vehicles: [] };
  vehicles: any = [];
  mySearchKey
  PermitStatus10: any = 0;
  appId = 0;
  pdfSrc: any;
  isLoadingImg = false;
  loadCompleted: boolean = false;
  permitTypes: any = [];

  permitStatus1: number;    // Saved but not submitted
  permitStatus2: number;    // Submitted
  permitStatus4: number;    // Approved
  permitStatus6: number;    // Quote accepted
  permitStatus7: number;    // Quote & details accepted
  permitStatus8: number;    // Printed
  permitStatus10: number;   // Ready for printing
  permitStatus11: number;   // Expired
  permitStatus12: number;   // Rejeted or Declined
  permitStatus13: number;   // Returned
  permitStatus15: number;   // Cancelled

  constructor(private router: Router, private activeRoute: ActivatedRoute,
    private confirmDialogService:ConfirmDialogService,
    private carrierService: CarrierService,
    private permitService: PermitService,
    private statusService: StatusService,
    private applicationService: ApplicationService,
    private routeService: RouteService,
    private vehicleService: VehicleTypeService,
    public utility: UtilityServiceService,
    private toaster: ToastrService,
    private session: StorageService,
    private permitTypeService : PermitTypeService,
    public currformat: CurrencyFormat, public showModal: PopupService, private authWebService: AuthWebService) {
    this.user = (this.authWebService.userData) ? this.authWebService.userData.User : null;
  }

  onReset = () => {
    this.selectedItems = [];
    this.selectedPermitTypes = [];
    this.permitNumber = null;
    this.routeName = null; 
    this.initKeyword();
    this.utility.page = 1;
    this.message = 'Loading  permit applications, please wait...';
    this.getApplications();
  }

  onItemSelect(item: any) {
  }
  onDeSelect(item: any) {
  }
  onSelectAll(items: any) {
  }
  
  onSearch = () => {
    this.gridload = true;
    if (!this.isSearchable()) {
      this.toaster.info("Please provide at least one filter value.", "Permit Approval Search", { timeOut: 5000 });
      return;
    }
    this.setSearchKeywords();
    this.utility.page = 1;
    this.message = "Searching for carrier accounts, please wait...";

    this.carrierService.searchCarrierPermits(this.keyword, 1,this.keyword.CarrierID, this.pageSize, this.rankCtrl,this.direction).subscribe((result:any) => {
    this.permits = result.Items;    
    this.setApplicationData(result);    

    }, error => {
      this.gridload = false;
      this.loadCompleted = true;
      this.isEmpty=false;
    });

  }
  
  loadPermitTypes = () => {
    this.permitTypeService.get().subscribe(result => {
      this.permitTypes = result;
    });
  }
  // loadStatuses = () => {
  //   alert('loadStatuses');
  //   this.statusService.statusesDDL(2).subscribe(result => {
  //     this.statuses = result.map(row => {
  //       return { id: row.id, desc: row.desc };
  //     });
  //     // this.statuses.sort((a,b) => a.sort_order > b.sort_order ? 1 : -1 &&  a.group_code > b.group_code ? 1 : -1 &&  a.id > b.id ? 1 : -1)
  //     this.statuses.sort((a,b) => a.sort_order > b.sort_order ? 1 : -1 &&  a.desc > b.desc ? 1 : -1)
  //     this.loadAccounts();
  //   });

  // }

  setSearchKeywords = () => {
    this.keyword.CarrierID = this.dataCntrl.carrierID;    
    this.keyword.permitNumber=(this.permitNumber) ? this.permitNumber : "All";
    this.keyword.PermitTypes = (this.selectedPermitTypes) ? this.selectedPermitTypes.map(pt => { return pt.id; }) : [];
    this.keyword.Statuses = (this.selectedItems) ? this.selectedItems.map(status => { return status.id; }) : [];
  }
  initKeyword = () => {
    this.keyword = { permitNumber: "All", Statuses: [], PermitTypes: [] };
    this.retrieveDefaultStatuses();
  }

  isSearchable = () => {
    return (this.permitNumber != null ||this.routeName != null || this.selectedItems.length > 0 || this.selectedPermitTypes.length > 0);
  }
  checkKey(event){
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 13) {
      this.onSearch();
      return;
    }
  }
  retrieveDefaultStatuses = () => {
    if (this.authWebService.userData) {
      this.permitStatus2 = + this.authWebService.userData.Configurations.find(config => config.Code == "PermitStatus2").Value;  // submitted
      this.permitStatus4 = + this.authWebService.userData.Configurations.find(config => config.Code == "PermitStatus4").Value;  // approved
      this.permitStatus6 = + this.authWebService.userData.Configurations.find(config => config.Code == "PermitStatus6").Value;  // application and permit fee quote has been accepted
      this.permitStatus8 = + this.authWebService.userData.Configurations.find(config => config.Code == "PermitStatus8").Value;  // permit has been printed
      this.keyword.Statuses = [this.permitStatus2, 74]; // Submitted, STATUS CODE 74 = Submitted - Compliance
    }
  }

  InitMultiselect() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'description',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: this.ShowFilter,
      maxHeight: 210,
      closeDropDownOnSelection: false
    };
  }



  ngOnInit() {
    
    ////console.log(this.user);
    if (environment.authWebApi.systemData != null && environment.authWebApi.systemData.Configurations != null) {
      this.permitStatus1 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus1').Value;
      this.permitStatus2 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus2').Value;
      this.permitStatus4 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus4').Value;
      this.permitStatus6 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus6').Value;
      this.permitStatus7 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus7').Value;
      this.permitStatus8 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus8').Value;
      this.permitStatus10 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus10').Value;
      this.permitStatus11 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus11').Value;
      this.permitStatus12 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus12').Value;
      this.permitStatus13 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus13').Value;
      this.permitStatus15 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus15').Value;
    }
    this.PermitStatus10 = this.authWebService.userData.Configurations.find(p => p.Code == 'PermitStatus10').Value
    if (this.router.url.indexOf('cancel') > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.carrierID = params['id'];
        this.appId = params['appid'];
      }

      );
    }
    this.activeRoute.params.subscribe((params: Params) => {
      this.dataCntrl.carrierID = params['id'];
    }

    );
    this.utility.changeKey = 0;
    this.getStatus();
    this.loadPermitTypes();
    this.getApplications();
    this.getCarrier(); 
    this.loadAccounts();
    
    this.initKeyword();
   // this.loadStatuses();
    this.getRoutes();
    this.InitMultiselect();
    // this.getAllVehicleTypes();

   
  }

  copyPermit(id) {
    this.gridload = true;
    this.permitService.copyPermit(id).subscribe((data:any) => {
      this.gridload = false;
      //console.log(data);
      let num_of_renewals: any = data.application.permit_type.num_renewals_allowed;
      
      let renewal_count: any = data.application.permits.find(p=>p.id == id).renewal_num;
      if (num_of_renewals == 0 || renewal_count > num_of_renewals) {
        if (num_of_renewals == 0) {
          this.toaster.error("Permit Renewal is not allowed on this Permit Type", "Renew Permit");
        } else {
          this.toaster.error("You have already exceeded the renewal limit on this permit", "Renew Permit");
        }
        $("#selectControl option[value='']").prop('selected', true);
        return false;
      } else {
        this.renewPermit(data, id);
      }
    })
  }

  renewPermit(data, id) {
    let myPermit = data.application.permits[data.application.permits.length -1];
    //alert(JSON.stringify(myPermit));
    if (myPermit.renewal_num == null) {
      myPermit.renewal_num = 1;
    } else {
      myPermit.renewal_num = parseInt(myPermit.renewal_num) + 1;
    }
    this.updatePermit(data, id);
  }

  
  updatePermit(res, id) {
    
    this.permitService.upadatePermit(res.application.permits.find(p=>p.id==id)).subscribe(result => {
      res.application.permit = result;
      res.permit = result;
      this.permitService.RenewPermit(res).subscribe((res1:any) => {
        console.log(res1);
        let url: any = "carrier/permit/application/renew/" + res1.permit.id + "/" + this.dataCntrl.carrierID + "/" + true;
        this.router.navigate([url]);

      })
    })
  }
  getApplications() {
    this.gridload = true;
    //console.log(this.dataCntrl);
    this.carrierService.getCarrierPermits(this.dataCntrl.carrierID, this.pageNumber, this.pageSize, this.appId).subscribe(result => {
          this.setApplicationData(result);
         
    }, error => {
      this.gridload = false;
      this.loadCompleted = true;
      this.isEmpty=false;
    });
    

  }
  onSort() {
    this.direction = !this.direction;
  }


  setApplicationData(data) {
    this.loadCompleted = false;
    
    //console.log(data);
    //console.log(data)
    data.Items.forEach(element => {
      element.total_fees = this.formatCurrency(element.total_fees);
    });

    let count: any = 0;
    //this.dataCntrl.applications = [];
    let listItems: any = [];
    listItems = data.Items;

    

    let arrayList: any = [];
    let permitList: any = [];
    listItems.forEach(item => {
      permitList.push(item.permits)
      //.permits = item.permits
      this.vehicles = item.vehicle

      // permitList.push(item.vehicle)
      // permitList = [ ...item.permits, ...item.vehicle];

      

      //console.log("------------" + JSON.stringify(this.dataCntrl.applications));
    })

    listItems.forEach(currentItem => {
      let permit: any = currentItem;
      this.applicationService.getById(permit.application_id).subscribe(result => {
        let application: any = result;
        //alert(JSON.stringify(application));
        // application.permit.id = permit.id;
        // application.permit.permit_num = permit.permit_num;

        // insert permit status
        let status: any = this.statuses.find(x => x.id == permit.status_id);
        application.status_id = status.id;
        application.status = status.description;

        // retrieve the route description
        // let route: any = this.routes.find(rt => rt.id == application.route_id);
        // //console.log(this.routes);
        // //console.log(route);
        // application.route_desccription = route.description;

        application.registration_number = permit.vehicle_reg_num;

        // if (application.vehicle.length > 0) {
        //   this.getVehicle(application, permit.id);
        // } else {
        //   application.vehicle_type_code = "";
        //   application.vehicle_type = "";
        // }          
        // let vehicle: any = application.vehicle.find(x => x.permit_id == permit.id);
        // application.vehicle_type_code = vehicle.code;
        // application.vehicle_type = vehicle.description;        

        permit.application = application;
        arrayList.push(Object.assign({},permit)); 

      }, error => {
        this.gridload = false;
        permit.application = null;
        arrayList.push(Object.assign({},permit));
        
      });
      count++;
    });

    
    setTimeout(() => {
      //alert(JSON.stringify(arrayList));
      this.gridload = false;
      this.Count = data.Count;
      this.dataCntrl.permits = arrayList;
     // alert(JSON.stringify(this.dataCntrl.permits));
      //console.log(this.dataCntrl.applications)
      this.loadCompleted = true;
    }, 6000);
  }

  sortByAsc(list) {
    
    return list.sort((a, b) => {
      var x = a.permit_num + a.permit_issue; var y = b.permit_num + b.permit_issue;
      return ((x < y) ? -1 : (x > y) ? 1 : 0);
    });
  }

  getStatus() {
    this.statusService.getAll().subscribe(result => {
      this.statuses = result;     
    })
  } 

  // getStatusDesc(app, id) {
  //   if (id != null) {
  //     let status: any = this.statuses.find(x => x.id == id);

  //     app.status_id = id
  //     app.status = status.code;
  //     app.status_desc = status.description;
  //   } 
  //   else {
  //     app.status_desc = ""
  //   }
  // }

  getRoutes() {
    this.routeService.getAllRoute().subscribe(data => {
      //console.log(data);
      this.routes = data;
    });
  }

  // getPlaceDesc(res) {
  //   if (res.routes_id != null) {
  //     let route: any = this.routes.find(x => x.id == res.routes_id);
  //     res.route_code = route.code;
  //     res.route_desc = route.description;
  //   } else {
  //     res.route_code = "";
  //     res.route_desc = "";
  //   }
  // }

  // getVehicle(res, id) {

  //   let vehicleList = res.vehicle;
  //   let code: string = '';
  //   let description: string = '';

  //   if (id != null) {

  //     let vehicle: any = vehicleList.find(x => x.permit_id == id);
  //     if (vehicle != undefined && vehicle != null) {

  //       let vType: any = this.vehTypes.find(x => x.id == vehicle.vehicle_type_id);
  //       if (vType != undefined && vType != null) {

  //         code = vType.code;
  //         description = vType.description;
  //       }
  //     }
  //   }

  //   res.vehicle_type_code = code;
  //   res.vehicle_type = description;
  // }

  // getAllVehicleTypes() {
  //   this.vehicleService.loadvehicletypes().subscribe(data => {
  //     //console.log(data);
  //     this.vehTypes = data;
  //   });
  // }

  formatCurrency(value) {
    return accounting.formatMoney(value, 'R', 2, ' ', '.');
  }

  getCarrier() {
    this.pageload = true;
    this.carrierService.getById(this.dataCntrl.carrierID).subscribe(result => {
      this.setCarrierData(result);
      //console.log(result)
      this.pageload = false;
    }, error => {
      this.pageload = false;
      //console.log(error);
    });
  }

  setCarrierData(data) {
    if (data.account_balance != 0) {
      data.account_balance = -(parseFloat(data.account_balance));
    }
    data.account_balance = data.account_balance != 0 ? this.currformat.transform(parseFloat(data.account_balance)) : 'R 0.00';
    this.dataCntrl.carrier = data;    
  }
  loadAccounts() {
    if (this.user) {
      this.carrierService.listCarrierAccountsByUserId(this.user.Id).subscribe((result:any) => {
        //console.log(result.find(x => x.id == this.dataCntrl.carrierID))
        this.acc = result.find(x => x.id == this.dataCntrl.carrierID);
        if (this.acc.account_balance != 0) {
          this.acc.account_balance = -(parseFloat(this.acc.account_balance));
        }
        //console.log("this.acc " +JSON.stringify( this.acc) );
      }, error => {

      })
    }
  }
  onBack() {
    this.router.navigateByUrl('/carrier/accounts');
  }

  editApplication(id) {

   this.router.navigateByUrl(`/carrier/permit/edit/${id}`);
   
  }

  viewApplication(id) {
    this.router.navigateByUrl(`/carrier/permit/edit/${id}/false`); //false to just the application
  }

  onPage(page) {
    this.pageNumber = page
    this.getApplications();
    return page;
  }

  pageSizeName(value) {
    if (value === this.pageSizeMax) return 'All';
    return value;
  }

  pageSizes() {
    return [5, 10, 25, 50, 100, 500, this.pageSizeMax];
  }

  pageSizeChange() {
    this.getApplications();
  }
  navigatePermit1(item, change) {
    if (change.value == 'edit') {
      let url: any = "carrier/permit/application/edit/" + item.id;
      this.router.navigate([url]);
    }
    else {
      let permitStatus: any = environment.authWebApi.systemData.Configurations.find(config => config.Code == "PermitStatus9").Value;
      permitStatus = parseInt(permitStatus);
      let dateValidTo: any = item.application.permit.date_valid_to;
      let add30date: any = null;
      let dec30date: any = null;
      let currentDate: any = new Date();
      if (dateValidTo != null) {
        let mod = new Date(dateValidTo);
        mod.setDate(mod.getDate() + 30);
        add30date = mod;
        let mod1 = new Date(dateValidTo);
        mod1.setDate(mod1.getDate() - 30 + 1);
        dec30date = mod1;
        //console.log(currentDate);
        //console.log(dec30date);
        // if(item.status_id==permitStatus && dec30date.getTime()<=currentDate.getTime()){
        //   this.toaster.error("yy");
        //   return false;
        // }
        if (currentDate.getTime() < dec30date.getTime()) {
          this.toaster.error("You can only apply to renew a permit if it is within 30 days of expiry date.");
          return false;
        }
      }
      // this.showModal.showYesNo('Renew Permit', `Are you sure you want to renew ${item.permit_num} permit ?`, `You're about to renew permit`, 'Yes', 'No')
      //   .subscribe((isConfirmed) => {

      //     if (isConfirmed) {
      //       //console.log(item)
      //       this.copyPermit(item.id);

      //     } else {
      //       $("#selectControl option[value='']").prop('selected', true);
      //       return false;
      //     }
      //   });
        this.confirmDialogService.confirmThis(`Are you sure you want to renew ${item.permit_num} permit ?`, () => {  
          this.copyPermit(item.id);

      
        }, () =>  {  
          $("#selectControl option[value='']").prop('selected', true);
            return false;
        })

    }
  }

  navigatePermit(item, change) {
    localStorage.setItem("oldAppId",item.application.id);
    switch (change.value) {
      case 'view' :
          localStorage.setItem('permitNum',item.application.number_of_permits);
          this.router.navigate(['/carrier/permit/application/view', item.application.id]);
        break;

        case 'edit' :
          localStorage.setItem('permitNum',item.application.number_of_permits);
          this.router.navigate(['/carrier/permit/application/edit', item.application.id]);
        break;

      case 'duplicate':
        if(new Date(item.date_valid_to) < new Date())
            {
              this.toaster.warning(`Cannot duplicate an expired permit.`, `Duplicate Permit`);
              setTimeout(() => {
                this.getApplications();
                this.getCarrier();
                this.loadAccounts();
                this.toaster.clear();
                $("#selectControl option[value='']").prop('selected', true);
              }, 5000);
              return;
            }
        if (item.is_valid && item.application.permit_type.can_get_duplicate) {
          this.permitService.CheckPermitIssued(item.permit_num,item.permit_issue).subscribe(res=>{
            if(res){
              let username: any = this.user.LastName;
              this.permitService.ManageDuplicate(item.id, username).subscribe((data:any) => {
                let url: any = "carrier/permit/application/duplicate/" + data.appliId;
                this.router.navigate([url]);
              });
             }
             else{
              //this.toaster.error("You cannot request a duplicate for this permit because there is an application in progress for this permit or it's already issued.", "The permit is not a valid permit.");
              this.requestDeletePopup("Duplicate","There is a pending/ incomplete “Duplicate”  application for this Permit, please delete it before you start a new application", item );
              //this.getApplications();
              $("#selectControl option[value='']").prop('selected', true);
              return false;
            }
          })

          // let url: any = "carrier/permit/application/duplicate/" + item.id;
          // this.router.navigate([url]);
        }
        else {
          this.toaster.error("You cannot request a duplicate for this type of permit.", "The permit is not a valid permit.");
          $("#selectControl option[value='']").prop('selected', true);
          this.getApplications();
        }
        break;

      case 'renew':
        this.message = "Loading. Please wait..."
        this.gridload = true;
        let permitStatus: any = environment.authWebApi.systemData.Configurations.find(config => config.Code == "PermitStatus9").Value;
        permitStatus = parseInt(permitStatus);
        let dateValidTo: any = item.date_valid_to;
        let add30date: any = null;
        let dec30date: any = null;
        let currentDate: any = new Date();
        //console.log('renew');
        if (dateValidTo != null) {
          let mod = new Date(dateValidTo);
          mod.setDate(mod.getDate() + 30);
          add30date = mod;
          let mod1 = new Date(dateValidTo);
          mod1.setDate(mod1.getDate() - 30 + 1);
          dec30date = mod1;
          //console.log(currentDate);
          //console.log(dec30date);
          if (currentDate.getTime() < dec30date.getTime()) {
            this.toaster.error("You can only apply to renew a permit if it is within 30 days of expiry date.");
            this.getApplications();
            $("#selectControl option[value='']").prop('selected', true);
            return false;
          }
        }
        this.permitService.GetAllApplicationDetails(item.permit_num, item.renewal_num == null || item.renewal_num  == undefined? 0 :item.renewal_num ).subscribe(res => {
          this.gridload = false;
          if (res) {

            // this.showModal.showYesNo('Renew Permit', `Are you sure you want to renew permit ${item.permit_num} ?`, `Click 'Yes' to confirm or 'No' to abort`, 'Yes', 'No')
            //   .subscribe((isConfirmed) => {

            //     if (isConfirmed) {
            //       this.copyPermit(item.id);

            //     } else {
            //       $("#selectControl option[value='']").prop('selected', true);
            //       return false;
            //     }
            //   });
              this.confirmDialogService.confirmThis(`Are you sure you want to renew permit ${item.permit_num} ?`, () => {  
                this.copyPermit(item.id);

      
              }, () =>  {  
                $("#selectControl option[value='']").prop('selected', true);
                  return false;
              })
          } else {
            $("#selectControl option[value='']").prop('selected', true);
            this.toaster.error("You cannot Renew this permit as it is already renewed", "Renew Permit");
            return false;
          }
        } ,error => {
          this.toaster.error(`Error retrieving permit information. The server error response code is Error ${error.status} : ${error.statusText}`, `ERROR : Renew Permit`);
          $("#selectControl option[value='']").prop('selected', true);
          return;
        });
        break;
      case 'timetable':
      case 'route':
        ////console.log('Permit Data : ', item.application.permit.id);
        ////console.log('Username : ', this.user.LastName);
        if(new Date(item.date_valid_to) < new Date())
            {
              this.toaster.warning(`Cannot ammend route on expired permit.`, `Route Amendment`);
              setTimeout(() => {
                this.getApplications();
                this.getCarrier();
                this.loadAccounts();
                this.toaster.clear();
                $("#selectControl option[value='']").prop('selected', true);
              }, 5000);
              return;
            }

        this.permitService.CheckPermitIssued(item.permit_num,item.permit_issue).subscribe(res=>{
          if(res){
            const is_route = (change.value == 'route') ? true : false;
            this.utility.changeKey = 1;
            this.processChangeRoute(item.id, this.user.LastName, is_route, item);
          }else{
            //this.toaster.error("You cannot amend route for this permit because there is an application in progress this permit or it's already issued", "Route Amendment");
            this.requestDeletePopup("Route Amendment","There is a pending/ incomplete “Route Amendment”  application for this Permit, please delete it before you start a new application", item );
            $("#selectControl option[value='']").prop('selected', true);
            return false;
          }
        });
        break;
      case 'compliance':
        
        const compliance = {
          carrierId: item.application.carrier.id,
          carrierName: item.application.carrier.name,
          carrierNum: item.application.carrier.carrier_code,
          carrierTradingName: item.application.carrier.trading_name,
          carrierRegNum: item.application.carrier.registration_number,
          permitKey: item.id,
          permitNum: item.permit_num,
          permitType: item.application.permit_type.description,
          vehicle_reg_num: item.vehicle_reg_num,
          freight_passenger_ind: item.application.permit_type.freight_passenger_ind,
          url: `carrier/permit/application/mypermits/${item.application.carrier.id}`
        };
        // this.session.setCompliance(compliance);
        this.router.navigate(['/carrier/compliance/application'] ,{ queryParams: { id:item.application.carrier.id,appID:item.application_id, compID:item.id,typeId:item.permit_type_id} });

        // this.router.navigate([this.utility.cplURL]);
        break;
      case 'vehicle':       
        this.permitService.CheckPermitIssued(item.permit_num,item.permit_issue).subscribe(res=>{
          if(res){
            if(new Date(item.date_valid_to) < new Date())
            {
              this.toaster.warning(`Cannot replace vehicle on expired permit.`, `Vehicle Replacement`);
              setTimeout(() => {
                this.getApplications();
                this.getCarrier();
                this.loadAccounts();
                this.toaster.clear();
                $("#selectControl option[value='']").prop('selected', true);
              }, 5000);
              return;
            }
            if (item.application.vehicle.length > 0) {
              const is_vehicle = (change.value == 'vehicle') ? true : false;
              this.utility.changeKey = 3;
              this.processChangeVehicle(item.id, this.user.LastName, is_vehicle);
            }
            else
            {
              this.toaster.warning(`Please make sure that there is a vehicle to be replaced.`, `Vehicle Replacement`);
              setTimeout(() => {
                this.getApplications();
                this.getCarrier();
                this.loadAccounts();
                this.toaster.clear();
                $("#selectControl option[value='']").prop('selected', true);
              }, 5000);
            }
          }else{
            //this.toaster.error("You cannot Replace Vehicle for this permit because there is an application in progress this permit or it's already issued","Vehicle Replacement");
            this.requestDeletePopup("Vehicle Replacement","There is a pending/incomplete “Replacement”  application for this Permit, please delete it before you start a new application", item );
            
            $("#selectControl option[value='']").prop('selected', true);
            return false;
          }
        });
        break;
      case 'permitCorrection':
        if(new Date(item.date_valid_to) < new Date())
            {
              this.toaster.warning(`Cannot correct an expired permit.`, `Permit Correction`);
              setTimeout(() => {
                this.getApplications();
                this.getCarrier();
                this.loadAccounts();
                this.toaster.clear();
                $("#selectControl option[value='']").prop('selected', true);
              }, 5000);
              return;
            }
        this.permitService.CheckPermitIssued(item.permit_num,item.permit_issue).subscribe(res=>{
          if(res){
              this.manageCorrectPermit(item.id, this.user.LastName);
          }else{
            //this.toaster.error("You cannot do Error Correction for this permit because there is an application in progress for this permit or it's already issued","Error Correction");
            this.requestDeletePopup("Error Correction","There is a pending/ incomplete “Error Correction”  application for this Permit, please delete it before you start a new application", item );
            $("#selectControl option[value='']").prop('selected', true);
            return false;
          }
        });
        break;

      case 'myNum' :
        return this.router.navigate(['under-construction']);

      case 'confirm':

        //console.log('Permit status:' + item);
        if (item.status_id < this.permitStatus13) {
          this.toaster.warning("Permit must have been approved before you can confirm the details");
          return;
        }


        if (item.status_id > this.permitStatus7) {
          this.toaster.warning("Permit has already been processed and you cannot change it");
          return;
        }


        // this.router.navigate(['/carrier/permit/application/view/'], {queryParams: {id:item.application.permit.id, constatus: 2}});
        this.router.navigate(['/carrier/permit/application/view/' + item.application_id + '/' + 2]);
        break;

      case 'cancelApp':
        this.cancelApplication(item.id);
        break;
      case 'viewPermit':
        this.viewPrintedPermit(item.id);
        break;

        case 'delete':
          this.deleteApplication(item.id);
          break;
    }
  }

  requestDeletePopup(header, message, item)
  {
    let permDescription =  item.permit_num +'/' + (item.permit_issue+1);
    // this.showModal.showYesNo(header, message, `You're about to delete pending permit: ` + permDescription, 'Yes', 'No')
    //     .subscribe((isConfirmed) => {
    //       if (isConfirmed) {
    //         this.pageload = true;
    //        this.permitService.deletePermitByPermitNumAndIssueNum(item.permit_num, item.permit_issue+1).subscribe(deleted =>{
    //         this.pageload = true; 
    //         if(deleted)
    //          {
    //             this.toaster.success('Deleted Permit "' + permDescription + '", you can proceed' );
    //          }
    //          else{
    //           this.toaster.error('Cannot delete Permit "' + permDescription + '"' );
    //          }
    //        });
    //       } else {
            
    //         return false;
    //       }
    //     });
        this.confirmDialogService.confirmThis(message + " You're about to delete pending permit: "+ permDescription, () => {  
          
          this.pageload = true;
          this.permitService.deletePermitByPermitNumAndIssueNum(item.permit_num, item.permit_issue+1).subscribe(deleted =>{
           this.pageload = true; 
           if(deleted)
            {
               this.toaster.success('Deleted Permit "' + permDescription + '", you can proceed' );
            }
            else{
             this.toaster.error('Cannot delete Permit "' + permDescription + '"' );
            }
          });
      
        }, () =>  {  
          return false;
        })

  }

  viewPrintedPermit(id) {
    let obj = {
      pId: id,
      ReportName: 'Permit'

    }
    //console.log(obj);

    this.gridload = true;
    this.isLoadingImg = true;
    this.permitService.PrintingPermitView(obj).subscribe(data => {
      let objectURL = URL.createObjectURL(data);
      //console.log(objectURL);
      document.getElementById('btnShowPrintView').click()
      this.pdfSrc = objectURL;
      this.gridload = false;
      this.isLoadingImg = false;

    })
  }
  isCanBeAmended = (item: any) => {
    const data = item;
    if (!data.permits[0].is_valid)
      return false;
    else {
      return (data.permit_type.can_amend_route || data.permit_type.can_amend_timetable || data.permit_type.can_replace_vehicle);
    }
  }

  isComplianceReturned = (item: any) => {
    const data = item.application;
    //console.log(data.permit);
    return (data.permit.cplce_return_id > 0);

  }



  processChangeRoute = (perm_id, username, is_route,application) => {
    this.message = 'Processing your request, please wait...!';
    this.gridload = true;
    localStorage.setItem("timetable",application.application.permit_type.timetable_reqd);
    this.permitService.changeRoute(perm_id, username, is_route).subscribe((resp:any) => {
      this.gridload = false;
      let url: any = `carrier/permit/application/change/${resp.appliId}/${is_route}`;
      this.router.navigate([url]);

    }, error => {
      this.gridload = false;
      this.toaster.error("Your request could not be processed succesfully.Please contact the system admin if the problem persists.");

    });
  }

  processChangeVehicle(permit_id, username, isVehicle) {
    this.message = 'Processing your request, please wait...!';
    this.gridload = true;
    this.permitService.changeVehicle(permit_id, username, isVehicle).subscribe((resp:any) => {
      this.gridload = false;
      let url: any = `carrier/permit/application/change/${resp.appliId}/vehicle`;
      this.router.navigate([url]);

    }, error => {
      this.gridload = false;
      this.toaster.error("Your request could not be processed succesfully.Please contact the system admin if the problem persists.");

    });
  }
  manageCorrectPermit(id, user) {
    this.message = 'Processing your request, please wait...!';
    this.gridload = true;
    let correctDays1: any = environment.authWebApi.systemData.Configurations.find(config => config.Code == "CorrectDays1").Value;

    this.permitService.managePermitCorrection(id).subscribe(data => {
      if (data === true) {
        this.processPermitCorrection(id, user);
        // let url: any = `carrier/permit/application/change/${appid}/correction`;//remove when permit type code is avail
        // this.router.navigate([url]);
      } else {
        // let url: any = `carrier/permit/application/change/${appid}/correction`;
        // this.router.navigate([url]);
        this.toaster.error('You cannot request a change after ' + correctDays1 + ' day(s)');
        $("#selectControl option[value='']").prop('selected', true);
      }
      this.gridload = false;

    }, error => {
      this.gridload = false;
      this.toaster.error("Your request could not be processed succesfully.Please contact the system admin if the problem persists.");
      $("#selectControl option[value='']").prop('selected', true);
    })

  }
  processPermitCorrection(perm_id, username) {
    this.permitService.corrections(perm_id, username).subscribe((resp:any) => {
      let url: any = `carrier/permit/application/change/${resp.appliId}/correction`;
      this.router.navigate([url]);

    }, error => {
      this.toaster.error("Your request could not be processed succesfully.Please contact the system admin if the problem persists.");

    });
  }
  cancelApplication(id) {
    
      this.confirmDialogService.confirmThis('Are you sure that you want to cancel your application. If your application fee has been paid you cannot get it refunded. If your permit fee has been paid, you must contact us to apply for a refund.', () => {  
          
        this.confirmDialogService.confirmThis('You are about to cancel your permit. Press Yes to continue and cancel the permit.', () => {  
          
          this.message = 'Processing your request, please wait...!';
          this.gridload = true;

          this.permitService.UpdatePermitStatus(id).subscribe(data => {
            if (data === true) {
              this.toaster.success('The permit was cancelled successfully');
              this.getApplications();

            } else {

              // this.toaster.error('You cannot request a change after ' + correctDays1 + ' day(s)');
            }
            this.gridload = false;

          }, error => {
            this.gridload = false;
            this.toaster.error("Your request could not be processed succesfully.Please contact the system admin if the problem persists.");

          })

      
        }, () =>  {  
          return false;
        })
      
      }, () =>  {  
        return false;
      })
  }


  deleteApplication(applicationData) {
   
 
          
     this.confirmDialogService.confirmThis('Are you sure you want to delete this permit application?.', () => {  
        
        this.message = 'Processing your request, please wait...!';
        this.gridload = true;

          this.applicationService.deleteApplication(applicationData.id).subscribe(data => { 
          if (data === true) {
            this.toaster.success('The Permit Application was deleted successfully');
            this.getApplications();
            console.log("app",applicationData.id);

          } else {

            // this.toaster.error('You cannot request a change after ' + correctDays1 + ' day(s)');
         }
          this.gridload = false;

        }, error => {
          this.gridload = false;
          this.toaster.error("Your request could not be processed succesfully.Please contact the system admin if the problem persists.");

        })
    
    }, () =>  {  
      return false;
   })
}


 // deleteApplication(id) {
   
 
          
      //  this.confirmDialogService.confirmThis('Are you sure you want to delete this permit application?.', () => {  
          
         // this.message = 'Processing your request, please wait...!';
          //this.gridload = true;

          //this.permitService.UpdatePermitStatus(id).subscribe(data => {
          //  this.permitService.deletePermit(id).subscribe(data => {
          //  if (data === true) {
             // this.toaster.success('The Permit Application was deleted successfully');
            //  this.getApplications();

           // } else {

              // this.toaster.error('You cannot request a change after ' + correctDays1 + ' day(s)');
           // }
           // this.gridload = false;

         // }, error => {
           // this.gridload = false;
           // this.toaster.error("Your request could not be processed succesfully.Please contact the system admin if the problem persists.");

         // })
      
    //  }, () =>  {  
       // return false;
     // })
 // }








}
